<p>network-status works!</p>
